import { useEffect, useRef, useState } from "react";
import { scrollToForm } from "@/App";

const PANEL_CSS = `
  .c2h-pay{--navy:#011B47;--teal:#13AFDC;--green:#8FD67A;--muted:#A9B7CC;--line:rgba(255,255,255,.12);
    width:100%;max-width:560px;color:#fff;position:relative;font-family:'Work Sans',system-ui,Arial,sans-serif}
  .c2h-pay *{box-sizing:border-box;margin:0;padding:0}
  .c2h-pay .eyebrow{font-size:12px;font-weight:700;letter-spacing:.2em;color:var(--green);margin-bottom:14px}
  .c2h-pay .card{position:relative;overflow:hidden;border-radius:24px;padding:34px 30px 28px;
    background:radial-gradient(120% 80% at 85% 0%,rgba(19,175,220,.28),transparent 55%),linear-gradient(160deg,#04306e,#011B47 70%);
    border:1px solid var(--line);box-shadow:0 30px 70px rgba(0,0,0,.35)}
  .c2h-pay .orb{position:absolute;border-radius:50%;filter:blur(2px);opacity:.5;animation:drift 9s ease-in-out infinite}
  .c2h-pay .o1{width:140px;height:140px;right:-40px;top:-30px;background:radial-gradient(circle,rgba(143,214,122,.45),transparent 70%)}
  .c2h-pay .o2{width:90px;height:90px;left:-20px;bottom:60px;background:radial-gradient(circle,rgba(19,175,220,.45),transparent 70%);animation-delay:-4s}
  @keyframes drift{50%{transform:translate(-14px,12px)}}
  .c2h-pay .big{display:flex;align-items:flex-end;gap:14px}
  .c2h-pay .zero{font-family:'Playfair Display',Georgia,serif;font-weight:700;font-size:110px;line-height:.85;
    background:linear-gradient(120deg,#8FD67A,#13AFDC 60%,#8FD67A);background-size:200% 100%;-webkit-background-clip:text;background-clip:text;color:transparent;animation:shine 5s linear infinite}
  @keyframes shine{to{background-position:-200% 0}}
  .c2h-pay .big span{font-size:20px;font-weight:600;line-height:1.25;padding-bottom:8px}
  .c2h-pay .sub{color:var(--muted);font-size:14.5px;margin:14px 0 22px;line-height:1.5}
  .c2h-pay .lab{font-size:13px;font-weight:600;color:#fff;margin-bottom:10px}
  .c2h-pay .seg{display:flex;background:rgba(255,255,255,.07);border:1px solid var(--line);border-radius:999px;padding:4px;position:relative}
  .c2h-pay .seg .pill{position:absolute;top:4px;bottom:4px;left:4px;width:calc(50% - 4px);border-radius:999px;background:var(--teal);transition:transform .45s cubic-bezier(.7,0,.2,1)}
  .c2h-pay .seg.m18 .pill{transform:translateX(100%)}
  .c2h-pay .seg button{flex:1;position:relative;z-index:1;border:0;background:none;color:var(--muted);font:600 14px inherit;padding:11px;cursor:pointer;transition:color .3s}
  .c2h-pay .seg button.on{color:var(--navy)}
  .c2h-pay .track{margin:18px 0 6px;display:grid;gap:5px}
  .c2h-pay .dot{height:10px;border-radius:3px;background:rgba(255,255,255,.12);transform:scaleY(.4);transition:background .3s,transform .3s}
  .c2h-pay .dot.lit{background:linear-gradient(var(--green),var(--teal));transform:scaleY(1)}
  .c2h-pay .tcap{display:flex;justify-content:space-between;font-size:12px;color:var(--muted)}
  .c2h-pay .tcap b{color:#fff}
  .c2h-pay .ticks{list-style:none;padding:0;margin:20px 0 22px;display:grid;gap:10px}
  .c2h-pay .ticks li{display:flex;gap:10px;align-items:center;font-size:14.5px;opacity:0;transform:translateX(-8px);transition:.5s}
  .c2h-pay.in .ticks li{opacity:1;transform:none}
  .c2h-pay.in .ticks li:nth-child(2){transition-delay:.15s}.c2h-pay.in .ticks li:nth-child(3){transition-delay:.3s}.c2h-pay.in .ticks li:nth-child(4){transition-delay:.45s}
  .c2h-pay .ticks i{width:22px;height:22px;border-radius:50%;background:rgba(143,214,122,.16);display:grid;place-items:center;flex:0 0 22px}
  .c2h-pay .steps{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:22px}
  .c2h-pay .step{background:rgba(255,255,255,.05);border:1px solid var(--line);border-radius:14px;padding:12px 10px;text-align:center;cursor:pointer;transition:.3s}
  .c2h-pay .step .n{width:28px;height:28px;border-radius:50%;margin:0 auto 6px;display:grid;place-items:center;font-weight:700;font-size:13px;background:rgba(255,255,255,.1);transition:.3s}
  .c2h-pay .step b{display:block;font-size:12.5px;line-height:1.3}
  .c2h-pay .step.on{border-color:var(--teal);background:rgba(19,175,220,.12)}
  .c2h-pay .step.on .n{background:var(--teal);color:var(--navy)}
  .c2h-pay .desc{min-height:44px;font-size:13.5px;color:#D7E0EC;line-height:1.5;margin:-8px 0 20px;transition:opacity .25s}
  .c2h-pay .cta{display:block;width:100%;border:0;border-radius:14px;padding:17px;font:700 17px inherit;color:var(--navy);background:var(--teal);cursor:pointer;position:relative;overflow:hidden;box-shadow:0 12px 30px rgba(19,175,220,.35);transition:transform .2s}
  .c2h-pay .cta:hover{transform:translateY(-2px)}
  .c2h-pay .cta:after{content:'';position:absolute;top:0;left:-60%;width:40%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent);transform:skewX(-20deg);animation:sweep 3.2s ease-in-out infinite}
  @keyframes sweep{60%,100%{left:130%}}
  .c2h-pay .fine{font-size:11.5px;color:#8A97AD;margin-top:12px;line-height:1.5;text-align:center}
  @media (prefers-reduced-motion:reduce){.c2h-pay *{animation:none!important;transition:none!important}}
`;

const TICKS = [
  "0% interest, fees apply",
  "12 or 18 month terms",
  "Fortnightly repayments",
  "For heat pump hot water systems",
];

const STEPS = [
  { t: "Get your fixed quote", d: "We confirm your system and your price, with rebates applied." },
  { t: "Apply with Brighte", d: "Pay a small deposit, create your Brighte account and Brighte verifies your details." },
  { t: "We install", d: "Pick 12 or 18 months. Once Brighte confirms, we book your install." },
];

const BrightePayPanel = () => {
  const rootRef = useRef(null);
  const [inView, setInView] = useState(false);
  const [months, setMonths] = useState(12);
  const [lit, setLit] = useState(0);
  const [step, setStep] = useState(0);
  const [descVisible, setDescVisible] = useState(true);
  const interacted = useRef(false);

  const repayments = months === 18 ? 39 : 26;

  // Reveal + start auto-cycle when scrolled into view
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    if ("IntersectionObserver" in window) {
      const o = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              setInView(true);
              o.disconnect();
            }
          });
        },
        { threshold: 0.2 }
      );
      o.observe(root);
      return () => o.disconnect();
    }
    setInView(true);
  }, []);

  // Repayment dots light up progressively whenever the term changes (once visible)
  useEffect(() => {
    if (!inView) return;
    setLit(0);
    const t = setInterval(() => {
      setLit((l) => {
        if (l >= repayments) {
          clearInterval(t);
          return l;
        }
        return l + 1;
      });
    }, 45);
    return () => clearInterval(t);
  }, [inView, repayments]);

  // Auto-cycle the 3 steps until the visitor interacts
  const stepRef = useRef(0);
  useEffect(() => {
    if (!inView) return;
    const auto = setInterval(() => {
      if (!interacted.current) showStep((stepRef.current + 1) % 3);
    }, 3500);
    return () => clearInterval(auto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const showStep = (i) => {
    stepRef.current = i;
    setDescVisible(false);
    setTimeout(() => {
      setStep(i);
      setDescVisible(true);
    }, 200);
  };

  const pickStep = (i) => {
    interacted.current = true; // stop auto-cycling, like the original
    showStep(i);
  };

  return (
    <div
      ref={rootRef}
      data-testid="brighte-panel"
      className={`c2h-pay${inView ? " in" : ""}`}
    >
      <style>{PANEL_CSS}</style>
      <div className="eyebrow">PAY OVER TIME WITH BRIGHTE</div>
      <div className="card">
        <div className="orb o1"></div>
        <div className="orb o2"></div>
        <div className="big">
          <div className="zero">0%</div>
          <span>
            interest
            <br />
            payment plans
          </span>
        </div>
        <p className="sub">
          Get your Rinnai heat pump installed now and spread the cost with
          Brighte, paid fortnightly.
        </p>

        <div className="lab">Choose your plan length</div>
        <div className={`seg${months === 18 ? " m18" : ""}`} data-testid="brighte-seg">
          <div className="pill"></div>
          <button
            type="button"
            className={months === 12 ? "on" : ""}
            onClick={() => setMonths(12)}
            data-testid="brighte-seg-12"
          >
            12 months
          </button>
          <button
            type="button"
            className={months === 18 ? "on" : ""}
            onClick={() => setMonths(18)}
            data-testid="brighte-seg-18"
          >
            18 months
          </button>
        </div>
        <div
          className="track"
          data-testid="brighte-track"
          style={{ gridTemplateColumns: `repeat(${repayments},1fr)` }}
        >
          {Array.from({ length: repayments }).map((_, i) => (
            <div key={i} className={`dot${i < lit ? " lit" : ""}`}></div>
          ))}
        </div>
        <div className="tcap">
          <span>Install day</span>
          <span>
            <b data-testid="brighte-repayments">{repayments}</b> fortnightly
            repayments
          </span>
          <span>Paid off</span>
        </div>

        <ul className="ticks">
          {TICKS.map((t) => (
            <li key={t}>
              <i>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#8FD67A" strokeWidth="3">
                  <path d="M5 12l4 4 10-10" />
                </svg>
              </i>
              {t}
            </li>
          ))}
        </ul>

        <div className="steps" data-testid="brighte-steps">
          {STEPS.map((s, i) => (
            <div
              key={s.t}
              className={`step${step === i ? " on" : ""}`}
              data-testid={`brighte-step-${i}`}
              onMouseEnter={() => pickStep(i)}
              onClick={() => pickStep(i)}
            >
              <div className="n">{i + 1}</div>
              <b>{s.t}</b>
            </div>
          ))}
        </div>
        <p
          className="desc"
          data-testid="brighte-desc"
          style={{ opacity: descVisible ? 1 : 0 }}
        >
          {STEPS[step].d}
        </p>

        <button
          type="button"
          className="cta"
          onClick={scrollToForm}
          data-testid="brighte-cta"
        >
          See My Price
        </button>
        <p className="fine">
          0% interest. Fees apply. Subject to Brighte credit approval. Not
          available for emergency repairs. Brighte Capital Pty Ltd, ACL 508217.
        </p>
      </div>
    </div>
  );
};

export default BrightePayPanel;
